import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HighlightsBar from "./components/HighlightsBar";
import Story from "./components/Story";
import CinematicVideo from "./components/CinematicVideo";
import Gallery from "./components/Gallery";
import FloorplanVideo from "./components/FloorplanVideo";
import Features from "./components/Features";
import Neighborhood from "./components/Neighborhood";
import MapSection from "./components/MapSection";
import Makelaar from "./components/Makelaar";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import StickyCallBar from "./components/StickyCallBar";
import ShareBar from "./components/ShareBar";
import WhatsAppButton from "./components/WhatsAppButton";
import MortgageCalculator from "./components/MortgageCalculator";
import LeadForm from "./components/LeadForm";
import AdminLeads from "./components/AdminLeads";
import CookieBanner from "./components/CookieBanner";
import Redirect from "./components/Redirect";
import SmoothScroll from "./components/SmoothScroll";

function getRedirectTarget() {
  if (typeof window === "undefined") return null;
  const path = window.location.pathname.replace(/\/+$/, "").toLowerCase();
  const goto = new URLSearchParams(window.location.search).get("goto");
  const aliases = {
    "/funda": "funda",
    "/listing": "funda",
    "/makelaar-website": "makelaar",
  };
  if (aliases[path]) return aliases[path];
  if (goto && ["funda", "makelaar"].includes(goto.toLowerCase()))
    return goto.toLowerCase();
  return null;
}

function App() {
  const path = typeof window !== "undefined"
    ? window.location.pathname.replace(/\/+$/, "").toLowerCase()
    : "";

  if (path === "/admin" || path === "/admin/leads") {
    return <AdminLeads />;
  }

  const redirectTarget = getRedirectTarget();
  if (redirectTarget) {
    return <Redirect target={redirectTarget} />;
  }

  return (
    <div className="App" data-testid="app-root">
      <SmoothScroll />
      <Header />
      <main>
        <Hero />
        <HighlightsBar />
        <Story />
        <CinematicVideo />
        <Gallery />
        <FloorplanVideo />
        <Features />
        <MortgageCalculator />
        <Neighborhood />
        <MapSection />
        <Makelaar />
        <LeadForm />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCallBar />
      <ShareBar />
      <WhatsAppButton />
      <CookieBanner />
    </div>
  );
}

export default App;
